import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-147">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-148">
        {/* Ebook Mockup Image */}
        <div className="mb-10" data-id="element-149">
          <img src="https://cdn.magicpatterns.com/uploads/mQmUxAeCUkQ3zcw8hcYUWx/mockupcrochet.png" alt="Ebook Bikinis al Crochet - Vista previa en tablet" className="max-w-[320px] md:max-w-sm mx-auto rounded-2xl shadow-xl" data-id="element-150" />
        </div>

        {/* Headline */}
        <h1 className="font-heading font-bold text-3xl md:text-5xl text-dark-gray leading-tight mb-6" data-id="element-151">
          Aprende a Tejer tu Primera Bikini al Crochet en Menos de 24 Horas
        </h1>

        {/* Subtitle */}
        <p className="font-body text-lg md:text-xl text-medium-gray leading-relaxed mb-8 max-w-[580px] mx-auto" data-id="element-152">
          De "siempre abandono todo" a usar una bikini que hiciste vos misma —
          sin experiencia previa, sin patrones confusos, solo resultados reales.
        </p>

        {/* CTA */}
        <div className="mb-10" data-id="element-153">
          <CTAButton onClick={() => document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-154">
            👉 Sí, Quiero Aprender — Acceso Inmediato Ahora
          </CTAButton>
        </div>

        {/* Identification Block */}
        <div className="bg-beige rounded-2xl shadow-md p-6 md:p-8 mb-8 text-left" data-id="element-155">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-dark-gray mb-5 text-center" data-id="element-156">
            Este ebook es para vos si…
          </h2>
          <ul className="space-y-3 font-body text-dark-gray" data-id="element-157">
            <li className="flex items-start gap-3" data-id="element-158">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-159">📌</span>
              <span data-id="element-160">
                Ya intentaste aprender crochet antes — y nunca terminaste nada
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-161">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-162">📌</span>
              <span data-id="element-163">
                Guardaste decenas de tutoriales que nunca tuvieron sentido
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-164">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-165">📌</span>
              <span data-id="element-166">Sentís que "no tenés el talento" para esto</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-167">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-168">📌</span>
              <span data-id="element-169">
                Estás cansada de pagar $60–$100 por bikinis que podrías hacer
                vos misma
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-170">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-171">📌</span>
              <span data-id="element-172">
                Querés crear algo con tus manos — y por fin terminarlo
              </span>
            </li>
          </ul>
        </div>

        {/* Italic callout */}
        <p className="italic text-pink-dark font-body text-base md:text-lg mb-10" data-id="element-173">
          ✨ Si te identificaste con aunque sea uno de estos puntos — seguí
          leyendo. Esto fue hecho para vos.
        </p>
      </div>
    </section>;
}